import Login from "@/components/Account/Login.vue";
import Recover from "@/components/Account/Recover.vue";
import ResetPassword from "@/components/Account/ResetPassword.vue";
import Administration from "@/components/Layout/Administration.vue";
import Dashboard from "@/components/Admin/Dashboard/Dashboard.vue";
import AccountIndex from "@/components/Admin/Account/AccountIndex.vue";
import AccountCreate from "@/components/Admin/Account/AccountCreate.vue";
import AccountEdit from "@/components/Admin/Account/AccountEdit.vue";
import AccountMange from "@/components/Admin/Account/AccountManage.vue";
import CampaignIndex from "@/components/Admin/Campaign/CampaignIndex.vue";
import CampaignCreate from "@/components/Admin/Campaign/CampaignCreate.vue";
import CampaignEdit from "@/components/Admin/Campaign/CampaignEdit.vue";
import CampaignManage from "@/components/Admin/Campaign/CampaignManage.vue";
import CampaignProductManage from "@/components/Admin/Campaign/CampaignProductManage.vue";
import CampaignCodeCreate from "@/components/Admin/Campaign/CampaignCodeCreate.vue";
import CampaignCodeOrderShow from "@/components/Admin/Campaign/CampaignCodeOrderShow.vue";
import OrderIndex from "@/components/Admin/Order/OrderIndex.vue";
import OrderManage from "@/components/Admin/Order/OrderManage.vue";
import Report from "@/components/Admin/Report/Report.vue";
import CreateEditReport from "@/components/Admin/Report/Manage/CreateEditReport.vue";
import CreateEdtSchedule from "@/components/Admin/Report/Schedule/CreateEditSchedule.vue";
import Settings from "@/components/Admin/Account/Settings.vue";
import UserIndex from "@/components/Admin/User/UserIndex.vue";
import UserInvite from "@/components/Admin/User/UserInvite.vue";
import UserUpdate from "@/components/Admin/User/UserUpdate.vue";
const adminRoutes = [
    { name: 'login', path: '/login', component: Login },
    { name: 'recover', path: '/recover', component: Recover },
    { name: 'reset', path: '/reset/:token', component: ResetPassword },
    {
        path: '/admin',
        component: Administration,
        children: [
            { name: 'admin.dashboard', path: '/admin', component: Dashboard, props: true },
            // Account
            { name: 'admin.account', path: '/admin/account', component: AccountIndex, props: true },
            { name: 'admin.account.create', path: '/admin/account/create', component: AccountCreate, props: true },
            { name: 'admin.account.manage', path: '/admin/account/:slug', component: AccountMange, props: true },
            { name: 'admin.account.edit', path: '/admin/account/:account/edit', component: AccountEdit, props: true },
            // user
            { name: 'admin.user', path: '/admin/user', component: UserIndex, props: true },
            { name: 'admin.user.invite', path: '/admin/user/invite', component: UserInvite, props: true },
            { name: 'admin.user.update', path: '/admin/user/:id', component: UserUpdate, props: true },
            // Campaign
            { name: 'admin.campaign', path: '/admin/campaign', component: CampaignIndex, props: true },
            { name: 'admin.campaign.create', path: '/admin/campaign/create', component: CampaignCreate, props: true },
            { name: 'admin.campaign.manage', path: '/admin/:account/campaign/:slug', component: CampaignManage, props: true },
            { name: 'admin.campaign.edit', path: '/admin/:account/campaign/:slug/edit', component: CampaignEdit, props: true },
            // Campaign Products
            { name: 'admin.campaign.product.manage', path: '/admin/:account/campaign/:slug/product', component: CampaignProductManage, props: true },
            // Campaign Codes
            { name: 'admin.campaign.code.create', path: '/admin/:account/campaign/:slug/code/create', component: CampaignCodeCreate, props: true },
            { name: 'admin.campaign.code.show', path: '/admin/:account/campaign/:slug/code/:order', component: CampaignCodeOrderShow, props: true },
            // Order
            { name: 'admin.order', path: '/admin/order', component: OrderIndex, props: true },
            { name: 'admin.order.manage', path: '/admin/order/:slug', component: OrderManage, props: true },
            // Report
            { name: 'admin.report', path: '/admin/report', component: Report, props: true },
            { name: 'admin.report.schedule.create', path: '/admin/report/schedule/create', component: CreateEdtSchedule, props: true },
            { name: 'admin.report.schedule.edit', path: '/admin/report/schedule/:schedule/edit', component: CreateEdtSchedule, props: true },
            { name: 'admin.report.create', path: '/admin/report/create', component: CreateEditReport, props: true },
            { name: 'admin.report.edit', path: '/admin/report/:report/edit', component: CreateEditReport, props: true },
            // User
            { name: 'admin.settings', path: '/admin/settings', component: Settings, props: true },
        ]
    }
];
export { adminRoutes };
